export default function circularProgress({ variables, }) {
    return {
        MuiCircularProgress: {
            styleOverrides: {
                colorPrimary: {
                    color: variables.interactive,
                },
            },
        },
    };
}
//# sourceMappingURL=circularProgress.js.map